// extracted by mini-css-extract-plugin
module.exports = {"StarRating":"StarRating_StarRating__3RGqX","IconGridItem":"StarRating_IconGridItem__3pDIQ","Icon":"StarRating_Icon__3JXL4"};